import React, {FunctionComponent} from 'react';
import {Card, CardContent, Grid, Typography} from "@material-ui/core";
import css from "./services.module.css";
import CodeIcon from "@material-ui/icons/Code";
import ArchitectureIcon from "@material-ui/icons/AccountTree";
import RateReviewIcon from "@material-ui/icons/RateReview";
import BuildIcon from "@material-ui/icons/Build";

interface Service {
    title: string;
    description: string;
    icon: React.ReactNode;
}

const Services: FunctionComponent = () => {
    const services: Service[] = [
        {
            title: "End to End Software Development",
            description: "End-to-end development of scalable, maintainable applications tailored to your business needs. From concept to deployment, using modern technologies and best practices.",
            icon: <CodeIcon className={css.serviceIcon} />
        },
        {
            title: "Technical Consulting & Test Automation",
            description: "Expert guidance on architecture, technology stack, and system design. Introduction of automated testing strategies to ensure code quality and confidence in your releases.",
            icon: <ArchitectureIcon className={css.serviceIcon} />
        },
                {
            title: "AI-Generated Code Rescue",
            description: "Struggling with vibe-coded projects? I help fix, refactor, and improve code generated by AI tools—turning quick prototypes into production-ready, maintainable software.",
            icon: <BuildIcon className={css.serviceIcon} />
        },
        {
            title: "Code Review & Mentoring",
            description: "Comprehensive code reviews to improve quality and team skills. Personalized mentoring sessions to help developers grow and adopt best practices.",
            icon: <RateReviewIcon className={css.serviceIcon} />
        },
    ];

    return (
        <Grid container justifyContent={"center"} className={css.servicesGrid}>
            <Grid item xs={11} sm={8} md={7}>
                <Grid container spacing={2}>
                    {services.map((service, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Card className={css.serviceCard}>
                                <CardContent className={css.cardContent}>
                                    <div className={css.iconWrapper}>
                                        {service.icon}
                                    </div>
                                    <Typography variant={"h6"} className={css.serviceTitle}>
                                        {service.title}
                                    </Typography>
                                    <Typography variant={"body2"} className={css.serviceDescription}>
                                        {service.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Services;
